/** This file is auto generated by convertSvgToJsx.js */

import React from 'react'
const reset = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="m5.333 14.474.634-.401-.128-.202-.22-.09-.286.693Zm1.084-3.807a.75.75 0 0 0-1.5 0h1.5ZM5.667 15v.75a.75.75 0 0 0 .75-.75h-.75Zm-4.334-.75a.75.75 0 0 0 0 1.5v-1.5Zm8.007-.144a.75.75 0 1 0 .32 1.466l-.32-1.466ZM1.75 8A6.25 6.25 0 0 1 8 1.75V.25A7.75 7.75 0 0 0 .25 8h1.5ZM8 1.75A6.25 6.25 0 0 1 14.25 8h1.5A7.75 7.75 0 0 0 8 .25v1.5ZM5.62 13.78A6.252 6.252 0 0 1 1.75 8H.25a7.752 7.752 0 0 0 4.797 7.168l.572-1.387Zm-.703-3.113V15h1.5v-4.333h-1.5Zm.75 3.583H1.333v1.5h4.334v-1.5Zm-.967.626.333.526 1.267-.803-.333-.526-1.267.803ZM14.25 8a6.253 6.253 0 0 1-4.91 6.106l.32 1.466A7.753 7.753 0 0 0 15.75 8h-1.5Z"
    />
  </svg>
)
export default reset
